<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Sample Type Table Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <b-tabs card>
      <b-tab title="Analytes" active>
        <h3>Sample Type Analytes</h3>
        <analyte-server-table
          :show_columns="[
            'name',
            'modus_name',
            'abbrev',
            'description'
          ]"
        />
      </b-tab>
      <b-tab title="Instructions">
        <h3>
          Service Instructions
          <b-button
            v-if="sample_type_id"
            variant="link"
            :href="`#/sampletypes/${sample_type_id}/instructions/update`"
            class="float-right"
            title="Edit Service Instructions">
            <i class="fal fa-pencil" />
          </b-button>
        </h3>
        <div
          class="message"
          v-if="service_instruction && service_instruction.message"
          v-html="service_instruction.message"
        >
          {{ service_instruction.message }}
        </div>
        <b-alert v-else show>
          No Service Instructions from this sample type.
        </b-alert>
      </b-tab>
      <b-tab title="Questions">
        <h3>
          Service Questions
          <b-button
            v-if="laboratory_id"
            variant="link"
            :href="`#/laboratory/${laboratory_id}/service-questions/update/${sample_type_id}`"
            class="float-right"
            title="Edit Service Questions"
          >
            <i class="fal fa-pencil" />
          </b-button>
        </h3>
        <service-question-server-table :laboratory_id="laboratory_id" />
      </b-tab>
      <b-tab title="Turnaround">
          <h3>Turnaround Options</h3>
          <turnaround-server-table
            :show_columns="['name','turnaround','surcharge','description']"
            :laboratory_id="laboratory_id"
          />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import AnalyteServerTable from "@/components/lab/analyte/AnalyteServerTable";
import ServiceQuestionServerTable from "@/components/lab/servicequestion/ServiceQuestionServerTable";
import TurnaroundServerTable from "@/components/lab/turnaround/TurnaroundServerTable";
import SampleTypeModel from '@/models/lab/SampleTypeModel';
import { getCollection } from "@/shared/fetch-utils";

export default {
  name: 'SampleTypeDetailCardstack',
  props: {
    sample_type: {
      type: Object,
      default: () => new SampleTypeModel()
    }
  },
  components: {
    AnalyteServerTable,
    ServiceQuestionServerTable,
    TurnaroundServerTable,
  },
  data() {
    return {
      loading: true,
      laboratory_id: this.$store.getters.getLaboratoryContext.id || null,
      sample_type_id: this.$route.params.sample_type_id || null,
      sample_type_collection: null,
    }
  },
  computed: {
    service_instruction() {
      return this.sample_type.service_instructions && this.sample_type.service_instructions.length
        ? this.sample_type.service_instructions[0]
        : null
    }
  },
  methods: {
    async init() {
      this.sample_type_collection = await getCollection({
        collection_type: "sample_type",
        message: this.$bvToast
      })
      this.loading = false;
    },
  },
  created() {
    this.init();

  }
}

</script>
